import { getAuthTokenAsync } from "src/store/common";
import { User, Meta } from "src/store/types";
import * as api from "./api";

interface ApiResponse {
  data: User[];
  meta: Meta;
}

// fetch user list
export const fetchUserList = async (data: {
  page: number;
  limit: number;
  search?: string;
  role?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  if (data.role && data.role.trim()) {
    params.role = data.role.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/users`,
    params,
  );
  return response;
};

// fetch reported users
export const fetchReportedUsers = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/users/reported-users`,
    params,
  );
  return response;
};

// fetch user reports
export const fetchUserReports = async (uid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/users/reported-users/${uid}`,
  );
  return response;
};

// block unblock user
export const blockUser = (uid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.get(`${process.env.REACT_APP_ADMIN_API_URL}/users/${uid}`);
};

// update user role as clapit member
export const updateUserRole = (uid: string, roleData: any) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.put(
    `${process.env.REACT_APP_ADMIN_API_URL}/users/${uid}`,
    roleData,
  );
};

// assign star
export const assignStar = (uid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.patch(
    `${process.env.REACT_APP_ADMIN_API_URL}/users/star/${uid}`,
    {},
  );
};

export const toggleSubscription = (uid: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.patch(
    `${process.env.REACT_APP_ADMIN_API_URL}/users/subscription/${uid}`,
    {},
  );
};
